export default {
  'Sample photo': 'Exemplo',
  Removing: 'Removendo',
  Edit: 'Editar',
  'Adjust Picture': 'Ajustar',
  Restore: 'Restaurar',
  Eraser: 'Borracha',
  Size: 'Tamanho',
  Background: 'Fundo',
  Custom: 'Personalizar',
  Presets: 'Predefinir',
  'Add Image': 'Adicionar Imagem',
  'Scale to Fit': 'Dimensionar para Caber',
  'Full Width': 'Largura Completa',
  'Full Height': 'Altura Máxima',
  Move: 'Mover',
  Undo: 'Desfazer',
  Redo: 'Refazer',
  Enlarge: 'Alargar',
  Reduce: 'Reduzir',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw Online Removedor de Fundo',
    desc: 'Remover Fundo de Imagem 100% Facilmente & Automaticamente & Grátis',
    imgAlt: 'photo background remover',
    submitBtn: 'Remover Fundo',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Sombra",
  "Intensity" : "Opacidade",
  "Radius" : "Raio",
  "Color" : "Cor",
  "Move" : "Mover sombra",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Arrastar a sombra na imagem",
  "Upload failed, click to try again": "Falha no upload, clique para tentar novamente",

};
